import React from 'react'
import s from './InlineErrorBanner.module.scss'

export const USER_FRIENDLY_ERROR =
	'Something went wrong. Please try again later.'

/** Log technical details; return a safe message for the UI. */
export const toUserFriendlyError = (error, fallback = USER_FRIENDLY_ERROR) => {
	const technical =
		error?.response?.data?.error ||
		error?.response?.data?.message ||
		error?.message ||
		error
	console.error('[Parent contacts]', technical, error)
	return fallback
}

/**
 * Inline red error banner for Parent Communication Contacts.
 * Page list: closable + optional Try again.
 * Modals: message only under header.
 */
export const InlineErrorBanner = ({
	message = USER_FRIENDLY_ERROR,
	onClose,
	onRetry,
	retrying = false,
}) => {
	if (!message) return null

	return (
		<div className={s.banner} role="alert">
			<div className={s.copy}>
				<span className={`material-icons-outlined ${s.icon}`} aria-hidden="true">
					error_outline
				</span>
				<span>{message}</span>
			</div>
			<div className={s.actions}>
				{typeof onRetry === 'function' ? (
					<button
						type="button"
						className={s.retry}
						onClick={onRetry}
						disabled={retrying}
					>
						{retrying ? 'Trying…' : 'Try again'}
					</button>
				) : null}
				{typeof onClose === 'function' ? (
					<button
						type="button"
						className={s.close}
						onClick={onClose}
						aria-label="Dismiss error"
						disabled={retrying}
					>
						<span className="material-icons-outlined" aria-hidden="true">
							close
						</span>
					</button>
				) : null}
			</div>
		</div>
	)
}

export default InlineErrorBanner
